/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AssignLeadCommand } from '../model/assignLeadCommand';
import { CaptureLeadIntentCommand } from '../model/captureLeadIntentCommand';
import { GetLeadsQueryResult } from '../model/getLeadsQueryResult';
import { InlineResponse404 } from '../model/inlineResponse404';
import { IntentType } from '../model/intentType';
import { LeadModel } from '../model/leadModel';
import { LeadStatusType } from '../model/leadStatusType';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class LeadsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsAssignPost(body?: AssignLeadCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public leadsAssignPost(body?: AssignLeadCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public leadsAssignPost(body?: AssignLeadCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public leadsAssignPost(body?: AssignLeadCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Leads/Assign`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param filterName 
     * @param filterEmail 
     * @param filterPhoneNumber 
     * @param filterSSN 
     * @param filterIntent 
     * @param filterStatus 
     * @param filterBrokerUid 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<GetLeadsQueryResult>;
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetLeadsQueryResult>>;
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetLeadsQueryResult>>;
    public leadsGet(filterName?: string, filterEmail?: string, filterPhoneNumber?: string, filterSSN?: string, filterIntent?: IntentType, filterStatus?: LeadStatusType, filterBrokerUid?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (filterName !== undefined && filterName !== null) {
            queryParameters = queryParameters.set('Filter.Name', <any>filterName);
        }
        if (filterEmail !== undefined && filterEmail !== null) {
            queryParameters = queryParameters.set('Filter.Email', <any>filterEmail);
        }
        if (filterPhoneNumber !== undefined && filterPhoneNumber !== null) {
            queryParameters = queryParameters.set('Filter.PhoneNumber', <any>filterPhoneNumber);
        }
        if (filterSSN !== undefined && filterSSN !== null) {
            queryParameters = queryParameters.set('Filter.SSN', <any>filterSSN);
        }
        if (filterIntent !== undefined && filterIntent !== null) {
            queryParameters = queryParameters.set('Filter.Intent', <any>filterIntent);
        }
        if (filterStatus !== undefined && filterStatus !== null) {
            queryParameters = queryParameters.set('Filter.Status', <any>filterStatus);
        }
        if (filterBrokerUid !== undefined && filterBrokerUid !== null) {
            queryParameters = queryParameters.set('Filter.BrokerUid', <any>filterBrokerUid);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetLeadsQueryResult>('get',`${this.basePath}/Leads`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public leadsIntentPost(body?: CaptureLeadIntentCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Leads/Intent`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public leadsMineGet(observe?: 'body', reportProgress?: boolean): Observable<LeadModel>;
    public leadsMineGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<LeadModel>>;
    public leadsMineGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<LeadModel>>;
    public leadsMineGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<LeadModel>('get',`${this.basePath}/Leads/Mine`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
